import { render, staticRenderFns } from "./ShiftStatusBadge.vue?vue&type=template&id=5476c625&"
import script from "./ShiftStatusBadge.vue?vue&type=script&lang=js&"
export * from "./ShiftStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports